import { Injectable } from '@angular/core';
import { TagStagePhase } from '../models/tag-stage-phase.model';

@Injectable({ providedIn: 'root' })
export class RecruitmentUtilsService {

    public generateStagesHierarchy(index: number, totalItems: number): string {
        if (index == 1) {
          return TagStagePhase.CLASS_STAGE_HIERARCHY_1;
        } else if (index == totalItems) {
          return TagStagePhase.CLASS_STAGE_HIERARCHY_10;
        } else {
          const INDEX = Math.round((index / totalItems) * 10);
          return 'tag--hierarchy-' + INDEX;
        }
      }
}
